import { render, staticRenderFns } from "./password-find.vue?vue&type=template&id=05d2ef24&scoped=true&"
import script from "./password-find.vue?vue&type=script&lang=js&"
export * from "./password-find.vue?vue&type=script&lang=js&"
import style0 from "./password-find.vue?vue&type=style&index=0&id=05d2ef24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2ef24",
  null
  
)

export default component.exports